
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { useHistory } from "react-router-dom";

// react-bootstrap components
import {
    Badge,
    Button,
    Card,
    Form,
    InputGroup,
    Navbar,
    Nav,
    Table,
    Container,
    Row,
    Col,
    OverlayTrigger,
    Tooltip,
    ListGroup
} from "react-bootstrap";

import TenantList from '../../Common/TenantList/TenantList';

import '../TenantSetup.scss';

import { useAppState } from "../../../state";

import LightningControllersPanel from './LightningControllersPanel';

const LightningControllersPage = (props) => {
    let tenantSetup = undefined;

    const { user, app, onAppStateRefresh } = useAppState();

    const [selectedTenant, setSelectedTenant] = useState();

    const handleSelectTenant = (tenant) => {
        setSelectedTenant(tenant);
    }


    if (selectedTenant) {
        tenantSetup = (<LightningControllersPanel tenant={selectedTenant} onBackButtonClick={() => handleSelectTenant()}/>);
    }

    return (
        <Container fluid className="setupView" id="RouterViewPage">

                <Row>
                    <TenantList user={user} onSelectTenant={(t) => handleSelectTenant(t)} selectedTenant={selectedTenant} />
                    {tenantSetup}
                </Row>

            </Container>
    );
};

export default LightningControllersPage;
